import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Slide,
  Typography,
} from "@material-ui/core";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  Calendar,
  CreditCard,
  DownloadSimple,
  Sparkle,
  Stack,
  Swap,
  User,
  Warning,
} from "phosphor-react";
import { useEffect, useState } from "react";
import { fget } from "../../API/callsAPI";
import Loader from "../Utilities/Loader/Loader";
import MyTeamBillDetailsSlider from "./MyTeamBillDetailsSlider";
import myTeamBillingsPageStyles from "./MyTeamBillingsPageStyles";

const MyTeamsBillingPage = ({
  teamId,
  currentTierDetails,
  setIsChoosePlanModalOpen,
  setSnackValue,
}) => {
  const classes = myTeamBillingsPageStyles();

  const [viewPaymentDetailsSliderData, setViewPaymentDetailsSliderData] =
    useState({
      isOpen: false,
      data: null,
    });
  const [invoices, setInvoices] = useState([]);
  const [isInvoicesLoading, setIsInvoicesLoading] = useState(true);
  const [isManagePaymentLoading, setIsManagePaymentLoading] = useState(false);

  const handleGetInvoices = async () => {
    try {
      setIsInvoicesLoading(true);
      const res = await fget({ url: `project-space/${teamId}/invoices/` });
      setInvoices(res?.data?.results || []);
      setIsInvoicesLoading(false);
    } catch (error) {
      console.log(error);
      setIsInvoicesLoading(false);
    }
  };

  useEffect(() => {
    handleGetInvoices();
  }, [teamId]);

  const handleManagePayments = async () => {
    try {
      setIsManagePaymentLoading(true);

      const res = await fget({
        url: `manage-payments/`,
      });

      setSnackValue({
        isOpen: true,
        message: "Redirecting to payment management...",
        isError: false,
      });

      if (res?.data?.url) {
        window.open(res?.data?.url, "_blank");
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: "Failed to open payment management.",
        isError: true,
      });
    } finally {
      setIsManagePaymentLoading(false);
    }
  };

  return (
    <Box className={classes.pageWrapper}>
      {/* Main Content */}
      <Box className={classes.contentWrapper}>
        {/* Current Plan */}
        <Box className={classes.card}>
          <Box className={classes.cardContent}>
            <Box className={classes.planHeader}>
              <Typography
                style={{
                  fontSize: "14px",
                }}
              >
                Your current plan
              </Typography>
              <span className={classes.planBadge}>
                {currentTierDetails?.tier}
              </span>
            </Box>

            <Divider className={classes.divider} />

            <Box className={classes.infoList}>
              <Box className={classes.infoRow}>
                <Box className={classes.infoLabel}>
                  <Calendar size={14} />
                  <Typography className={classes.commonText}>
                    Renewed On
                  </Typography>
                </Box>
                <Typography className={classes.infoValue}>
                  {currentTierDetails?.start_date
                    ? new Date(currentTierDetails?.start_date)?.toDateString()
                    : "--"}
                </Typography>
              </Box>
              <Box className={classes.infoRow}>
                <Box className={classes.infoLabel}>
                  <User size={14} />
                  <Typography className={classes.commonText}>
                    Team Seats
                  </Typography>
                </Box>
                <Typography className={classes.infoValue}>
                  {currentTierDetails?.tier_total_users}
                </Typography>
              </Box>
              <Box className={classes.infoRow}>
                <Box className={classes.infoLabel}>
                  <Stack size={14} />
                  <Typography className={classes.commonText}>
                    Storage
                  </Typography>
                </Box>
                <Typography className={classes.infoValue}>
                  {currentTierDetails?.tier_total_storage}
                </Typography>
              </Box>
              <Box className={classes.infoRow}>
                <Box className={classes.infoLabel}>
                  <Sparkle size={14} />
                  <Typography className={classes.commonText}>
                    AI Credits
                  </Typography>
                </Box>
                <Typography className={classes.infoValue}>
                  {currentTierDetails?.total_storage}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Billing Info */}
        <Box
          sx={{
            display: "flex",
            width: "100%",
          }}
        >
          <Box
            className={classes.card}
            sx={{
              width: "100%",
              maxWidth: "500px",
            }}
          >
            <Box
              className={classes.cardContent}
              style={{
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <Typography variant="h6">
                {currentTierDetails?.currency === "inr" ? "₹" : "$"}{" "}
                {(
                  Number(currentTierDetails?.previous_invoice_subtotal) / 100
                )?.toFixed(2)}{" "}
              </Typography>
              <Typography
                style={{
                  fontSize: "14px",
                }}
              >
                Next monthly invoice due on{" "}
                {currentTierDetails?.next_billing_date &&
                  new Date(
                    currentTierDetails.next_billing_date,
                  ).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
              </Typography>
              <Button
                startIcon={<CreditCard />}
                style={{
                  backgroundColor: "#6C65D94D",
                  borderRadius: "10px",
                  textAlign: "center",
                  width: "100%",
                  padding: "8px 16px",
                }}
                disabled={isManagePaymentLoading}
                onClick={handleManagePayments}
              >
                {isManagePaymentLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  "Manage Payments"
                )}
              </Button>
              <Button
                startIcon={<Swap />}
                style={{
                  backgroundColor: "#6C65D94D",
                  borderRadius: "10px",
                  textAlign: "center",
                  width: "100%",
                  padding: "8px 16px",
                }}
                onClick={() => setIsChoosePlanModalOpen(true)}
              >
                Change Plan
              </Button>
            </Box>
          </Box>
          {/* <Box
            sx={{
              width: "100%",
              display: "block",
            }}
          ></Box> */}
        </Box>
      </Box>
      {/* table  */}
      <Box>
        <TableContainer>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left" className={classes.tableHeaderCell}>
                  Due Date
                </TableCell>
                <TableCell align="left" className={classes.tableHeaderCell}>
                  Plan
                </TableCell>
                <TableCell align="left" className={classes.tableHeaderCell}>
                  Status
                </TableCell>
                <TableCell align="left" className={classes.tableHeaderCell}>
                  Fee
                </TableCell>
                <TableCell
                  align="left"
                  className={classes.tableHeaderCell}
                ></TableCell>
              </TableRow>
            </TableHead>
            {!isInvoicesLoading ? (
              <TableBody>
                <>
                  {invoices?.length ? (
                    invoices.map((invoice, index) => (
                      <TableRow
                        key={index}
                        onClick={() =>
                          setViewPaymentDetailsSliderData({
                            isOpen: true,
                            data: invoice,
                          })
                        }
                      >
                        <TableCell align="left" className={classes.tableCell}>
                          {new Intl.DateTimeFormat("en-US", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }).format(new Date(invoice?.created_at ?? ""))}
                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          <Typography className={classes.planBadge}>
                            {invoice?.tier}
                          </Typography>
                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          <Typography
                            className={
                              invoice?.status === "paid"
                                ? classes.paidStatus
                                : classes.pendingStatus
                            }
                          >
                            {invoice?.status}
                          </Typography>
                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          {(Number(invoice?.subtotal) / 100)?.toFixed(2)}{" "}
                          {invoice?.currency === "inr" ? "₹" : "$"}
                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: "16px",
                            }}
                          >
                            <Button
                              className={classes.leaveButton}
                              startIcon={<DownloadSimple size={14} />}
                              style={{
                                backgroundColor: "#6C65D929",
                                color: "#9992FF",
                                padding: "6px 8px",
                                borderRadius: "10px",
                                width: "120px",
                                textAlign: "center",
                                fontSize: "14px",
                                height: "30px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                window.open(invoice?.invoice_download_url);
                              }}
                            >
                              Invoice
                            </Button>
                            {invoice?.status?.toLowerCase() === "pending" ||
                            invoice?.status?.toLowerCase() === "failed" ? (
                              <Button
                                className={classes.leaveButton}
                                style={{
                                  backgroundColor: "#6C65D9",
                                  color: "#F9F9F9",
                                  padding: "6px 8px",
                                  borderRadius: "10px",
                                  width: "120px",
                                  textAlign: "center",
                                  fontSize: "14px",
                                  height: "30px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(invoice?.invoice_url);
                                }}
                              >
                                Pay Now
                              </Button>
                            ) : (
                              <Button
                                className={classes.leaveButton}
                                style={{
                                  display: "hidden",
                                  // backgroundColor: "#6C65D9",
                                  color: "#F9F9F9",
                                  padding: "6px 8px",
                                  borderRadius: "10px",
                                  width: "120px",
                                  textAlign: "center",
                                  fontSize: "14px",
                                  height: "30px",
                                }}
                                disabled
                              ></Button>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableCell colSpan={5}>
                      <Typography
                        style={{
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        No invoices found
                      </Typography>
                    </TableCell>
                  )}
                </>
              </TableBody>
            ) : (
              <Loader />
            )}
          </Table>
        </TableContainer>
      </Box>

      <Slide direction="left" in={viewPaymentDetailsSliderData.isOpen}>
        <div
          style={{
            display: viewPaymentDetailsSliderData ? "block" : "none",
            top: "82px",
            height: `calc(100vh - 185px)`,
          }}
          className={classes.floatingDiv}
        >
          <div
            style={{
              height: "100%",
              padding: "5px",
            }}
          >
            <MyTeamBillDetailsSlider
              handleClose={() =>
                setViewPaymentDetailsSliderData({ isOpen: false, data: null })
              }
              invoiceDetails={viewPaymentDetailsSliderData?.data}
            />
          </div>
        </div>
      </Slide>
    </Box>
  );
};

export default MyTeamsBillingPage;
